webpackJsonp([209752323273651],{

/***/ 133:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _CardGrid = __webpack_require__(104);
	
	__webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nArtistsPerRow = 4;
	
	var ArtistGrid = function (_Component) {
	  _inherits(ArtistGrid, _Component);
	
	  function ArtistGrid() {
	    _classCallCheck(this, ArtistGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ArtistGrid.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: data.title }),
	      _react2.default.createElement(_CardGrid.CardGrid, {
	        nCellsPerRow: nArtistsPerRow,
	        data: data.artists,
	        sizes: this.props.sizes,
	        isShort: this.props.isShort
	      })
	    );
	  };
	
	  return ArtistGrid;
	}(_react.Component);
	
	exports.default = { ArtistGrid: ArtistGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card() {
	    _classCallCheck(this, Card);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Card.prototype.render = function render() {
	    var data = this.props.data;
	    var img = _react2.default.createElement(_gatsbyImage2.default, { className: 'card-img', sizes: this.props.sizes });
	    var cardImg = data.isClickable ? _react2.default.createElement(
	      'a',
	      { target: '_blank', href: data.href },
	      img
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      img
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: "card" + (this.props.isShort ? " short" : " tall") },
	      cardImg,
	      _react2.default.createElement(
	        'div',
	        { className: 'card-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-name' },
	          data.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-info-block' },
	            _react2.default.createElement(
	              'div',
	              { style: { lineHeight: 1.5 } },
	              data.position
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-info-block' },
	            _react2.default.createElement(
	              'div',
	              { style: { lineHeight: 1.5 } },
	              data.affiliation
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-info-block' },
	            _react2.default.createElement(
	              'div',
	              { style: { lineHeight: 1.5 } },
	              data.affiliate_position
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Card;
	}(_react.Component);
	
	exports.default = { Card: Card };
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(30);
	
	var _Title = __webpack_require__(7);
	
	var _Grid = __webpack_require__(19);
	
	__webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nCellsPerRowMobile = 1;
	var nCellsPerRow = 4;
	
	var CardGrid = function (_Component) {
	  _inherits(CardGrid, _Component);
	
	  function CardGrid() {
	    _classCallCheck(this, CardGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CardGrid.prototype.render = function render() {
	    var _this2 = this;
	
	    var cards = this.props.data.map(function (datum, index) {
	      return _react2.default.createElement(_Card.Card, {
	        height: _this2.props.height,
	        isShort: _this2.props.isShort,
	        data: datum, sizes: _this2.props.sizes[index] });
	    });
	
	    return _react2.default.createElement(_Grid.Grid, {
	      data: cards,
	      nCellsPerRow: nCellsPerRow,
	      nCellsPerRowMobile: nCellsPerRowMobile
	    });
	  };
	
	  return CardGrid;
	}(_react.Component);
	
	exports.default = { CardGrid: CardGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _InfoBlockGrid = __webpack_require__(21);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nArtistsPerRow = 3;
	var nArtistsPerRowMobile = 1;
	
	var FeaturedArtists = function (_Component) {
	  _inherits(FeaturedArtists, _Component);
	
	  function FeaturedArtists() {
	    _classCallCheck(this, FeaturedArtists);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FeaturedArtists.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: data.title }),
	      _react2.default.createElement(_InfoBlockGrid.InfoBlockGrid, {
	        nCellsPerRow: nArtistsPerRow,
	        nCellsPerRowMobile: nArtistsPerRowMobile,
	        data: data.artists,
	        sizes: this.props.sizes })
	    );
	  };
	
	  return FeaturedArtists;
	}(_react.Component);
	
	exports.default = { FeaturedArtists: FeaturedArtists };
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(30);
	
	var _Title = __webpack_require__(7);
	
	__webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var desktopWidth = 720;
	var defaultMargin = 33;
	var mobilePadding = 21;
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      width: desktopWidth
	    };
	
	    _this.updateWidth = _this.updateWidth.bind(_this);
	    return _this;
	  }
	
	  Grid.prototype.componentDidMount = function componentDidMount() {
	    this.updateWidth();
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.updateWidth);
	    }
	  };
	
	  Grid.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.updateWidth);
	    }
	  };
	
	  Grid.prototype.updateWidth = function updateWidth() {
	    if (typeof window !== 'undefined') {
	      this.setState({ width: window.innerWidth < desktopWidth ? window.innerWidth - 2 * mobilePadding : desktopWidth });
	    }
	  };
	
	  Grid.prototype.renderRows = function renderRows(array, nCellsPerRow, marginTop, marginLeft) {
	    var _this2 = this;
	
	    var chunks = this.chunkByRows(array, nCellsPerRow);
	    return chunks.map(function (chunk, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index, className: 'row', style: { marginTop: index == 0 ? 0 : marginTop } },
	        _this2.renderRow(chunk, nCellsPerRow, marginLeft)
	      );
	    });
	  };
	
	  Grid.prototype.chunkByRows = function chunkByRows(array, nCellsPerRow) {
	    var chunkedArray = [];
	    var len = array.length;
	    for (var i = 0; i < len; i += nCellsPerRow) {
	      chunkedArray.push(array.slice(i, i + nCellsPerRow));
	    }
	
	    return chunkedArray;
	  };
	
	  Grid.prototype.computeCellWidth = function computeCellWidth(totalWidth, nCells, marginLeft) {
	    return (totalWidth - (nCells - 1) * marginLeft) / nCells;
	  };
	
	  Grid.prototype.renderRow = function renderRow(row, nCellsPerRow, marginLeft) {
	    var width = this.computeCellWidth(this.state.width, nCellsPerRow, marginLeft);
	    var cells = row.map(function (cell, index) {
	      var margin = index === 0 ? 0 : marginLeft;
	      return _react2.default.createElement(
	        'div',
	        { key: index, style: { width: width, marginLeft: margin }, className: 'cell' },
	        cell
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      ' ',
	      cells,
	      ' '
	    );
	  };
	
	  Grid.prototype.render = function render() {
	    var marginLeft = this.props.marginLeft ? this.props.marginLeft : defaultMargin;
	    var marginTop = this.props.marginTop ? this.props.marginTop : marginLeft;
	    var nCellsPerRow = this.state.width < desktopWidth ? this.props.nCellsPerRowMobile : this.props.nCellsPerRow;
	    var rows = this.renderRows(this.props.data, nCellsPerRow, marginTop, marginLeft);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      rows
	    );
	  };
	
	  return Grid;
	}(_react.Component);
	
	exports.default = { Grid: Grid };
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InfoBlock = __webpack_require__(37);
	
	var _Title = __webpack_require__(7);
	
	var _Grid = __webpack_require__(19);
	
	__webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nCellsPerRowMobile = 1;
	
	var InfoBlockGrid = function (_Component) {
	  _inherits(InfoBlockGrid, _Component);
	
	  function InfoBlockGrid() {
	    _classCallCheck(this, InfoBlockGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InfoBlockGrid.prototype.render = function render() {
	    var _this2 = this;
	
	    var title = this.props.title ? _react2.default.createElement(_Title.Title, { name: this.props.title }) : null;
	    var sizes = this.props.sizes;
	
	    var data = this.props.data.map(function (datum, index) {
	      return _react2.default.createElement(_InfoBlock.InfoBlock, {
	        descriptionStyleMod: _this2.props.descriptionStyleMod ? _this2.props.descriptionStyleMod : {},
	        containsImage: true,
	        hasModalImage: _this2.props.hasModalImage,
	        data: datum,
	        sizes: sizes[index] });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      title,
	      _react2.default.createElement(_Grid.Grid, {
	        marginTop: 50,
	        data: data,
	        nCellsPerRow: this.props.nCellsPerRow,
	        nCellsPerRowMobile: this.props.nCellsPerRowMobile })
	    );
	  };
	
	  return InfoBlockGrid;
	}(_react.Component);
	
	exports.default = { InfoBlockGrid: InfoBlockGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _Paragraph = __webpack_require__(32);
	
	var _InfoBlock = __webpack_require__(37);
	
	var _utils = __webpack_require__(33);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoSection = function (_Component) {
	  _inherits(InfoSection, _Component);
	
	  function InfoSection() {
	    _classCallCheck(this, InfoSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InfoSection.prototype.render = function render() {
	    var img = this.props.sizes ? _react2.default.createElement(_gatsbyImage2.default, { sizes: this.props.sizes }) : _react2.default.createElement('div', { style: { marginTop: -30 } });
	    var description = (0, _utils.renderParagraphs)(this.props.description);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: this.props.title }),
	      img,
	      _react2.default.createElement('br', null),
	      description
	    );
	  };
	
	  return InfoSection;
	}(_react.Component);
	
	exports.default = { InfoSection: InfoSection };
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InfoBlockGrid = __webpack_require__(21);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Grid = __webpack_require__(19);
	
	var _Title = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(2);
	
	__webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nJournalsPerRow = 3;
	var nJournalsPerRowMobile = 1;
	
	var Journals = function (_Component) {
	  _inherits(Journals, _Component);
	
	  function Journals() {
	    _classCallCheck(this, Journals);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Journals.prototype.render = function render() {
	
	    var images = this.props.data.journals.map(function (datum, index) {
	      return _react2.default.createElement(
	        'a',
	        { href: datum.href, target: '_blank' },
	        _react2.default.createElement('img', { src: datum.src })
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: this.props.data.title }),
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: -20 } },
	        _react2.default.createElement(_Grid.Grid, {
	          nCellsPerRow: nJournalsPerRow,
	          nCellsPerRowMobile: nJournalsPerRowMobile,
	          marginLeft: 0,
	          data: images })
	      )
	    );
	  };
	
	  return Journals;
	}(_react.Component);
	
	exports.default = { Journals: Journals };
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkBox = function (_Component) {
	  _inherits(LinkBox, _Component);
	
	  function LinkBox() {
	    _classCallCheck(this, LinkBox);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LinkBox.prototype.render = function render() {
	    var data = this.props.data;
	
	    var style = this.props.fixedWidth ? { width: this.props.fixedWidth } : {};
	
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'a',
	        { style: style, className: 'link-box', href: data.href, target: '_blank' },
	        data.text
	      )
	    );
	  };
	
	  return LinkBox;
	}(_react.Component);
	
	exports.default = { LinkBox: LinkBox };
	module.exports = exports['default'];

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _InfoBlockGrid = __webpack_require__(21);
	
	__webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nBlocksPerRow = 2;
	var nBlocksPerRowMobile = 1;
	
	var OverviewBlocks = function (_Component) {
	  _inherits(OverviewBlocks, _Component);
	
	  function OverviewBlocks() {
	    _classCallCheck(this, OverviewBlocks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OverviewBlocks.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_InfoBlockGrid.InfoBlockGrid, {
	        nCellsPerRowMobile: nBlocksPerRowMobile,
	        nCellsPerRow: nBlocksPerRow,
	        data: this.props.blocks,
	        sizes: this.props.sizes
	      })
	    );
	  };
	
	  return OverviewBlocks;
	}(_react.Component);
	
	exports.default = { OverviewBlocks: OverviewBlocks };
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(31);
	
	var _Footer = __webpack_require__(80);
	
	var _FeaturedArtists = __webpack_require__(105);
	
	var _ArtistGrid = __webpack_require__(103);
	
	var _OverviewBlocks = __webpack_require__(107);
	
	var _InfoSection = __webpack_require__(57);
	
	var _LinkBox = __webpack_require__(38);
	
	var _Journals = __webpack_require__(106);
	
	var _logo_color = __webpack_require__(100);
	
	var _logo_color2 = _interopRequireDefault(_logo_color);
	
	__webpack_require__(427);
	
	var _dataEn = __webpack_require__(39);
	
	var _dataEn2 = _interopRequireDefault(_dataEn);
	
	var _dataCn = __webpack_require__(58);
	
	var _dataCn2 = _interopRequireDefault(_dataCn);
	
	var _locale = __webpack_require__(28);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data = { en: _dataEn2.default, cn: _dataCn2.default };
	var localizedData = function localizedData() {
	  return data[_locale2.default.getLocale()];
	};
	var inaugural_season_page = localizedData().inaugural_season_page;
	var enIndex = 1;
	
	var InauguralSeasonPage = function (_Component) {
	  _inherits(InauguralSeasonPage, _Component);
	
	  function InauguralSeasonPage() {
	    _classCallCheck(this, InauguralSeasonPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InauguralSeasonPage.prototype.render = function render() {
	
	    var featuredArtistSizes = [this.props.data.ludovicMorlotImage.sizes, this.props.data.yujaWangImage.sizes, this.props.data.olgaKernImage.sizes];
	
	    var overviewSizes = [this.props.data.trainingResidencyImage.sizes, this.props.data.jointRehearsalImage.sizes, this.props.data.carnegieDebutImage.sizes, this.props.data.concertTourImage.sizes];
	
	    var teachingArtistSizes = [this.props.data.jindongCaiImage.sizes, this.props.data.frankHuangImage.sizes, this.props.data.qingLiImage.sizes, this.props.data.jayLiuImage.sizes, this.props.data.qiangTuImage.sizes, this.props.data.daxunZhangImage.sizes, this.props.data.sibeiWengImage.sizes, this.props.data.yaoguangZhaiImage.sizes, this.props.data.liangWangImage.sizes, this.props.data.feiXieImage.sizes, this.props.data.xiaomingHanImage.sizes, this.props.data.guangChenImage.sizes, this.props.data.weiZhuImage.sizes, this.props.data.haiyuWangImage.sizes, this.props.data.gertMortensenImage.sizes, this.props.data.jieyinWuImage.sizes];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header.Header, { src: _logo_color2.default, data: localizedData().header }),
	      _react2.default.createElement(
	        'div',
	        { className: 'margin-large' },
	        _react2.default.createElement(_InfoSection.InfoSection, {
	          title: inaugural_season_page.overview.title,
	          description: inaugural_season_page.overview.description,
	          sizes: this.props.data.carnegieConcertoImage.sizes }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_OverviewBlocks.OverviewBlocks, {
	          blocks: inaugural_season_page.overview_blocks,
	          sizes: overviewSizes }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_FeaturedArtists.FeaturedArtists, {
	          data: inaugural_season_page.featured_artists,
	          sizes: featuredArtistSizes }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_ArtistGrid.ArtistGrid, {
	          data: inaugural_season_page.teaching_artists,
	          sizes: teachingArtistSizes,
	          isShort: false }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_InfoSection.InfoSection, {
	          title: inaugural_season_page.class_of_2017.title,
	          description: inaugural_season_page.class_of_2017.description,
	          sizes: this.props.data.classOf2017Image.sizes }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_LinkBox.LinkBox, { data: inaugural_season_page.link_to_website })
	      ),
	      _react2.default.createElement(_Footer.Footer, null)
	    );
	  };
	
	  return InauguralSeasonPage;
	}(_react.Component);
	
	exports.default = InauguralSeasonPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2017-inaugural-season-jsx-796e4e98615100d77c8f.js